import { useUpdateStore } from "@/stores/update.store"
import { cn } from "@/lib/utils"
import { Icon } from "@/components/ui/icon"

/**
 * Barra fixa abaixo da navbar que informa sobre atualização do PWA.
 * Visível até o usuário clicar em Atualizar. Não interrompe o fluxo.
 */
export function UpdateBar() {
  const { needRefresh, updateSW } = useUpdateStore()

  if (!needRefresh || !updateSW) return null

  const handleUpdate = () => {
    updateSW()
  }

  return (
    <div
      className={cn(
        "w-full flex items-center justify-between gap-2 z-40 flex-nowrap",
        "px-2 py-1.5 sm:px-4 sm:py-2 min-h-0",
        "bg-amber-400 text-amber-950",
        "shadow-sm"
      )}
      role="banner"
      aria-live="polite"
    >
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <Icon name="system_update" />
        <span className="text-xs font-medium truncate leading-tight">
          Nova versão disponível. Atualize para continuar.
        </span>
      </div>
      <div className="flex items-center shrink-0">
        <button
          type="button"
          onClick={handleUpdate}
          className="px-3 py-1 rounded-md bg-amber-950/20 hover:bg-amber-950/30 font-semibold text-xs transition-colors"
        >
          Atualizar
        </button>
      </div>
    </div>
  )
}
